export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_DEV_URL + '/api'
    : process.env.REACT_APP_API_PROD_URL + '/api'
export const BASE_SOCKET_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_DEV_URL
    : process.env.REACT_APP_API_PROD_URL

// export const BASE_URL = 'http://31.172.70.163/api'
// export const BASE_SOCKET_URL = 'http://31.172.70.163'

export enum serverPath {
  LOGIN = '/auth/login',
  REFRESH = '/auth/refresh',
  CRM = 'crm',
  CRM_PERMISSIONS = '/crm/permission',
  CRM_USERS = 'crm/users',
  CRM_ADD = 'crm/add-crm',
  MAIN_STAT = 'crm/statistic',
  USERS = 'crm/users',
  USERS_MANAGER = 'users',
  USER_INFO = 'crm/users/',
  USER_TABLE = 'crm/user-table/',
  CRM_INFO = 'crm/statistic/',
  SALARY = 'salary',
  SALARY_INCOMES = 'salary/incomes',
  SALARY_EXPENSES = 'salary/expenses',
  SALARY_REPORTS = 'salary/reports',
  USER_CREATE = 'auth/create',
  BASES_LIGHT = '/bases/light',
  USERS_LIGHT = '/users/light',
  SERVER_EXPIRED = '/crm/server',
  BILLING = '/crm/billing/info',
  BILLING_SERVICES = '/balance',
  CRM_PRICE = '/crm/price',
  TELEPHONY = '/telephony',
  PHONE_OPERATOR = '/telephony-private',
  TARIFFS = '/tariffs',
  HASH = '/auth/generate-hash',
  BANNERS = '/banners',
  UPLOAD = '/upload',
}
